export const labelCallback = (units: string) =>
  function (context: any): string {
    if (context == null) {
      return "";
    }
    let label = context.dataset.label || "";

    if (label) {
      label = context.label + " " + label + ": ";
    }
    if (context.parsed.y !== null) {
      label += context.parsed.y + " " + units;
    }
    return label;
  };
